import ajax from './request'

/**
 * @param Vue
 * @param options 注册时携带可选的选项对象
 */
function install(app, options) {
  app.config.globalProperties.$ajax = ajax
}

export default {
  install
}
